import { FunctionTab } from '@/pages/function/constants/index';
import SubVisual from '@/components/SubVisual';
import { useState } from 'react';
import { Outlet } from 'react-router';

const FunctionPage = () => {
	const [activeTab, setActiveTab] = useState(0);

	const handleTabChange = (index: number) => {
		setActiveTab(index);
	};
	return (
		<>
			<main id="sub" className="sub function">
				<SubVisual
					cate={FunctionTab.cate}
					title={FunctionTab.title}
					subTab={FunctionTab.subTab}
					onChangeTab={handleTabChange}
				/>
				<Outlet />
			</main>
		</>
	);
};

export default FunctionPage;
